module.exports = __webpack_public_path__ + "30a84acba00e163b3057a4b51596958c.svg";